import script from "./AlertModalComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertModalComponent.vue?vue&type=script&setup=true&lang=ts"

import "./AlertModalComponent.vue?vue&type=style&index=0&id=0c1a4226&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1a4226"]])

export default __exports__